module.exports = __webpack_public_path__ + "img/email.9dc7889.png";